// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { useToaster } from "@insite/mobius/Toast/ToasterContext";
import { useIsSignedInAndhasToBeSignedIn } from "@store/Framework/Store/Context/ContextHooks";
import { useEffect } from "react";

const defaultAdjustmentText = translate("Your quantity has been adjusted.");

const useAutoAdjustQuantity = (
    quantity: number,
    minimumQuantity = 1,
    multipleSaleQty = 1,
    setQuantity: (quantity: number) => void,
    adjustmentText = defaultAdjustmentText,
) => {
    const minimumSaleQtyMessage = translate("MinimumSaleQty");
    const multipleSaleQtyMessage = translate("MultipleSaleQty");
    const isSignedInAndhasToBeSignedIn = useIsSignedInAndhasToBeSignedIn();
    const toaster = useToaster();
    const adjustQuantity = (showToast = true) => {
        let newQuantity = quantity;
        if (newQuantity < minimumQuantity) {
            newQuantity = minimumQuantity;
            if (showToast) {
                toaster.addToast({
                    body: `${adjustmentText} ${minimumSaleQtyMessage} ${minimumQuantity}`,
                    messageType: "warning",
                });
            }
        } else if (multipleSaleQty > 1 && newQuantity % multipleSaleQty !== 0) {
            newQuantity = Math.ceil(newQuantity / multipleSaleQty) * multipleSaleQty;
            if (showToast) {
                toaster.addToast({
                    body: `${adjustmentText} ${multipleSaleQtyMessage} ${multipleSaleQty}`,
                    messageType: "warning",
                });
            }
        }
        if (newQuantity !== quantity) {
            setQuantity(newQuantity);
        }
        return newQuantity;
    };
    useEffect(() => {
        if (isSignedInAndhasToBeSignedIn && multipleSaleQty && multipleSaleQty > 1) {
            adjustQuantity(false);
        } else if (minimumQuantity && quantity < minimumQuantity) {
            adjustQuantity(false);
        }
    }, [multipleSaleQty, minimumQuantity]);
    return adjustQuantity;
};

export default useAutoAdjustQuantity;
